import Text from '@deprecated-ui/common/Text';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import { assetPrefix } from 'constants/app';
import React from 'react';
import styled from 'styled-components';
import { DATA_CY_EBOOK_HEADER_EXPAND_BUTTON } from '../__tests__/constant';

const ExpandButton = styled.i`
  background: url(${assetPrefix}/icon/expand.svg);
  height: 12px;
  width: 12px;
  background-position: center right;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 12px 12px;
`;

export const SHeaderEbook = styled.div`
  align-items: center;
  background: ${color.light};
  border-radius: 3px;
  border: unset;
  display: flex;
  height: 40px;
  justify-content: space-between;
  margin-bottom: 0px;
  padding: 0px 20px;
  width: 100%;

  @media ${device.tablet} {
    border: 1px solid ${color.gainsboro};
    margin-bottom: 20px;
  }
`;

const Header = ({
  setIsPaneActive,
  isPaneActive,
}: {
  setIsPaneActive: (active: boolean) => void;
  isPaneActive: boolean;
}) => {
  const clickExpandHandler = () => {
    setIsPaneActive(false);
  };

  return (
    <SHeaderEbook>
      <Text as="span" family="bold" color={color.black} height="40px">
        All Ebook
      </Text>
      {isPaneActive && (
        <ExpandButton
          onClick={clickExpandHandler}
          data-cy={DATA_CY_EBOOK_HEADER_EXPAND_BUTTON}
        />
      )}
    </SHeaderEbook>
  );
};

export default Header;
